module.exports = {"generalDocs":{"title":"General Documents "},"popover":"Add general documents here.","addDocumentButton":"Add document +","meta":"Documents"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/documents.json
// module id = xZJn
// module chunks = 1